import { type FunctionComponent, useState } from 'react';

import { Link, WithTooltip, time } from '@dr.pogodin/react-utils';

import Status from 'components/Status';
import RemoveAdminModal from 'components/admin/RemoveAdminModal';

import { UserLink } from 'components/admin/UserLink';

import {
  MDASH,
  P_ADMIN_ADMIN_USERS,
  type UserT,
  getId,
} from 'utils';

import './style.scss';
import IconEdit from 'assets/images/icon-edit-16px.svg';
import IconTrash from 'assets/images/icon-trash-16px.svg';

type PropsT = {
  user: UserT;
};

const Item: FunctionComponent<PropsT> = ({ user }) => {
  let status: 'Active' | 'Inactive';
  if (user.roles.includes('OWNER')) status = 'Active';
  else if (user.adminSince) status = 'Inactive';
  else throw Error('The user is not an admin');

  const userUrl = `${P_ADMIN_ADMIN_USERS}/${user.id}`;

  const [showRemoveModal, setShowRemoveModal] = useState(false);

  return (
    <tr styleName="container">
      <td><UserLink to={userUrl} user={user} /></td>
      <td data-label="Admin ID">{user.id}</td>
      <td data-label="Admin Since">
        {user.adminSince ? time(user.adminSince).format('MMMM D, YYYY') : MDASH}
      </td>
      <td data-label="Status"><Status status={status} /></td>
      <td aria-label="Actions" styleName="bottom">
        <div styleName="icons">
          <WithTooltip tip="Edit Admin">
            <Link to={userUrl}>
              <IconEdit />
            </Link>
          </WithTooltip>
          <WithTooltip tip="Delete Admin">
            <Link
              onClick={() => {
                setShowRemoveModal(true);
              }}
              to=""
            >
              <IconTrash />
            </Link>
          </WithTooltip>
          {showRemoveModal ? (
            <RemoveAdminModal
              onCancel={() => {
                setShowRemoveModal(false);
              }}
              userId={getId(user)}
            />
          ) : null}
        </div>
      </td>
    </tr>
  );
};

export default Item;
